import {
  Dropzone,
  type FileRejection,
} from "@circleco/compass/components/Dropzone";

import { t } from "@/i18n-js/instance";

import { FILE_UPLOAD_ACCEPT_BY_TYPE } from "./constants";
import type { FileUploadType } from "./types";

interface UploadPanelProps {
  maxFileUploadSize: number;
  onFilesChange: (files: File[]) => void;
  onFilesRejected: (rejections: FileRejection[]) => void;
  type: FileUploadType;
}

export const UploadPanel = ({
  maxFileUploadSize,
  onFilesChange,
  onFilesRejected,
  type,
}: UploadPanelProps) => {
  const uploadDescription =
    type === "video"
      ? t("tiptap.drag_and_drop_any_video")
      : t(`tiptap.drag_and_drop_${type}`);

  return (
    <Dropzone
      isMultiple
      accept={FILE_UPLOAD_ACCEPT_BY_TYPE[type]}
      maxFileSize={maxFileUploadSize}
      title={t(`tiptap.choose_${type}`)}
      description={uploadDescription}
      onFilesChange={onFilesChange}
      onFilesRejected={onFilesRejected}
      className="mb-6 mt-2"
    />
  );
};
